// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isPlacePerkEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import {
  getUserName,
  getPointsToNextRewardState,
  getCurrentPointsState,
  getTotalRewardsState,
  isPlccUser,
  getTotalSpend,
  getCurrentPerkLevel,
  getSpendLeftForNextPerk,
} from '../../../../User/container/User.selectors';
import { fetchModuleX } from './AccountHeader.actions';
import { getRewardsPointsBannerContent } from './AccountHeader.selectors';
import AccountHeaderRedesign from '../views/AccountHeaderRedesign.view';
import AccountHeaderSagas from './AccountHeader.saga';
import AccountHeaderReducer from './AccountHeader.reducer';

export class AccountHeaderContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.labels = this.getOverviewLabels(props.labels);
    this.commonLabels = this.getCommonLabels(props.labels);
  }

  componentDidMount() {
    const { fetchRewardsPointsBannerContent, isPlcc } = this.props;
    const contentKey = `overviewRewardsPointsBanner${isPlcc ? 'PLCC' : 'MPR'}`;
    const contentObject = this?.labels?.referred?.find((ref) => ref.name === contentKey);
    if (contentObject && contentObject.contentId) {
      fetchRewardsPointsBannerContent(contentObject.contentId);
    }
  }

  getOverviewLabels = (labels) => {
    return (labels && labels.accountOverview) || {};
  };

  getCommonLabels = (labels) => {
    return (labels && labels.common) || {};
  };

  render() {
    const {
      name,
      currentPoints,
      pointsToNextRewards,
      totalRewards,
      isPlcc,
      placePerkEnabled,
      totalSpend,
      currentPerkLevel,
      spendLeftForNextPerk,
    } = this.props;
    return (
      <AccountHeaderRedesign
        labels={this.labels}
        name={name}
        pointsToNextRewards={pointsToNextRewards}
        currentPoints={currentPoints}
        totalRewards={totalRewards}
        isPlcc={isPlcc}
        isPlacePerkEnabled={placePerkEnabled}
        totalSpend={totalSpend}
        currentPerkLevel={currentPerkLevel}
        spendLeftForNextPerk={spendLeftForNextPerk}
      />
    );
  }
}

AccountHeaderContainer.propTypes = {
  commonLabels: PropTypes.shape({}),
  fetchRewardsPointsBannerContent: PropTypes.func.isRequired,
  isPlcc: PropTypes.bool,
  placePerkEnabled: PropTypes.bool,
  totalSpend: PropTypes.number,
  currentPerkLevel: PropTypes.string,
  spendLeftForNextPerk: PropTypes.number,
};

AccountHeaderContainer.defaultProps = {
  isPlcc: false,
  commonLabels: {},
  placePerkEnabled: false,
  totalSpend: 0,
  currentPerkLevel: 'DEFAULT',
  spendLeftForNextPerk: 0,
};

const mapStateToProps = (state) => ({
  name: getUserName(state),
  pointsToNextRewards: getPointsToNextRewardState(state),
  currentPoints: getCurrentPointsState(state),
  totalRewards: getTotalRewardsState(state),
  rewardsPointsBannerContent: getRewardsPointsBannerContent(state),
  isPlcc: isPlccUser(state),
  placePerkEnabled: isPlacePerkEnabled(state),
  totalSpend: getTotalSpend(state),
  currentPerkLevel: getCurrentPerkLevel(state),
  spendLeftForNextPerk: getSpendLeftForNextPerk(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchRewardsPointsBannerContent: (contentId) => {
    dispatch(fetchModuleX(contentId));
  },
});

const withReducer = withDynamicReducer({ key: 'AccountHeader', reducer: AccountHeaderReducer });
const withSaga = withDynamicSaga({ key: 'AccountHeader', saga: AccountHeaderSagas });
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withReducer, withSaga, withConnect)(AccountHeaderContainer);
